/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./index.less");

var _tool = require("../../../../utils/tool");

var _config = require("../../../../utils/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)("div", {
    className: "charge-tit"
}, void 0, "\u5B9E\u65F6\u6570\u636E\uFF1A");

var _ref2 = (0, _jsx3.default)("div", {
    className: "charge-tit"
}, void 0, "\u6781\u503C\u6570\u636E\uFF1A");

var _ref3 = (0, _jsx3.default)("div", {
    className: "equipment-fault-tit"
}, void 0, "\u6545\u969C\u4FE1\u606F");

var _ref4 = (0, _jsx3.default)("tr", {
    className: "equipment-fault-header"
}, void 0, (0, _jsx3.default)("td", {}, void 0, "\u5E8F\u53F7"), (0, _jsx3.default)("td", {}, void 0, "\u6545\u969C"), (0, _jsx3.default)("td", {}, void 0, "\u72B6\u6001"));

var Charge = function (_Component) {
    (0, _inherits3.default)(Charge, _Component);

    function Charge(props) {
        (0, _classCallCheck3.default)(this, Charge);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Charge.__proto__ || (0, _getPrototypeOf2.default)(Charge)).call(this, props));

        _this.state = {
            extre: [{ pattern: "最高允许温度(℃)", val: "", key: 'maxAllowTemperature' }, { pattern: "最高输出电压(v)", val: "", key: 'maxOutputVoltage' }, { pattern: "最低输出电压(v)", val: "", key: 'minOutputVoltage' }, { pattern: "最大输出电流(A)", val: "", key: 'maxOutputCurrent' }, { pattern: "最小输出电流(A)", val: "", key: 'minOutputCurrent' }],
            realVal: [],
            realTime: [{ pattern: "充电模式", val: "", key: 'chargeModeNumber' }, { pattern: "充电需求电压(v)", val: "", key: 'requireVoltage' }, { pattern: "充电需求电流(A)", val: "", key: 'requireCurrent' }, { pattern: "充电电压测量值(v)", val: "", key: 'measurementVoltageValue' }, { pattern: "充电电流测量值(A)", val: "", key: 'measurementCurrentValue' }, { pattern: "充电机当前温度(℃)", val: "", key: 'presentTemperature' }, { pattern: "固件版本1", val: "", key: 'firmware1Version' }, { pattern: "固件版本2", val: "", key: 'firmware2Version' }, { pattern: "电池连接状态", val: "", key: 'connectedBatteryPackIs' }],
            realTime2: [{ pattern: "充电模式", val: "", key: 'chargeModeNumber' }, { pattern: "充电需求电压(v)", val: "", key: 'requireVoltage' }, { pattern: "充电需求电流(A)", val: "", key: 'requireCurrent' }, { pattern: "充电电压测量值(v)", val: "", key: 'measurementVoltageValue' }, { pattern: "充电电流测量值(A)", val: "", key: 'measurementCurrentValue' }, { pattern: "充电机当前温度(℃)", val: "", key: 'presentTemperature' }],
            secondarys: []
        };
        return _this;
    }
    /*2019.8.22*/


    (0, _createClass3.default)(Charge, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.handleGetList();
            this.handleFault();
        }
    }, {
        key: "handleGetList",
        value: function handleGetList() {
            var _this2 = this;

            var param = {
                deviceId: this.props.deviceId,
                batteryCabinetNum: this.props.batteryCabinetNum
            };
            (0, _tool.http)(_config.apiJson.getCabinetChargerInfo, param || {}).then(function (res) {
                var realVal = _this2.props.deviceType !== '331' && _this2.props.deviceType != '332' && _this2.props.deviceType != '335' ? _this2.state.realTime2 : _this2.state.realTime;
                var result = res || {};
                realVal.forEach(function (item) {
                    if (item.pattern.indexOf('v') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else if (item.pattern.indexOf('A') !== -1) {
                        item.val = result[item.key] / 100 || '--';
                    } else if (item.pattern.indexOf('kwh') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else if (item.key === 'connectedBatteryPackIs') {
                        item.val = result[item.key] ? '已连接' : '已关闭';
                    } else if (item.key === 'chargeModeNumber') {
                        var tmp = {
                            '0': '恒压充电',
                            '1': '恒流充电',
                            '2': '未充电',
                            '255': '未知状态'
                        };
                        var str = result[item.key] || result[item.key] == 0 ? tmp[result[item.key]] : '--';
                        item.val = str;
                    } else {
                        item.val = result[item.key] || result[item.key] == 0 ? result[item.key] : '--';
                    }
                });
                _this2.state.extre.forEach(function (item) {
                    if (item.pattern.indexOf('v') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else if (item.pattern.indexOf('A') !== -1) {
                        item.val = result[item.key] / 100 || '--';
                    } else if (item.pattern.indexOf('kwh') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else {
                        item.val = result[item.key] || result[item.key] == 0 ? result[item.key] : '--';
                    }
                });
                _this2.setState({
                    realVal: realVal,
                    extre: _this2.state.extre
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
            });
        }
        // 故障列表

    }, {
        key: "handleFault",
        value: function handleFault() {
            var _this3 = this;

            var param = {
                deviceId: this.props.deviceId,
                batteryCabinetNum: this.props.batteryCabinetNum
            };
            (0, _tool.http)(_config.apiJson.getCabinetChargerFaultInfo, param || {}).then(function (res) {
                _this3.setState({
                    secondarys: res || []
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
                message.error(msg);
            });
        }
        /*------------------------------*/

    }, {
        key: "render",
        value: function render() {
            // const { realTime, extre } = this.state
            return (0, _jsx3.default)("div", {
                className: "charge"
            }, void 0, (0, _jsx3.default)("div", {
                className: "charge-realtime"
            }, void 0, _ref, (0, _jsx3.default)("div", {
                className: "charge-datas"
            }, void 0, this.state.realVal.map(function (res, i) {
                return (0, _jsx3.default)("div", {
                    className: "charge-xx"
                }, i, res.pattern, "\uFF1A", res.val);
            }))), (0, _jsx3.default)("div", {
                className: "charge-realtime"
            }, void 0, _ref2, (0, _jsx3.default)("div", {
                className: "charge-datas"
            }, void 0, this.state.extre.map(function (res, i) {
                return (0, _jsx3.default)("div", {
                    className: "charge-xx"
                }, i, res.pattern, "\uFF1A", res.val);
            }))), (0, _jsx3.default)("div", {
                className: "equipment-fault"
            }, void 0, _ref3, (0, _jsx3.default)("table", {
                className: "equipment-fault-info",
                style: { width: "33%" }
            }, void 0, _ref4, this.state.secondarys.map(function (res, i) {
                return (0, _jsx3.default)("tr", {
                    className: "equipment-fault-footer"
                }, i, (0, _jsx3.default)("td", {}, void 0, i + 1, ". "), (0, _jsx3.default)("td", {}, void 0, _tool.filter.faultInfo(res.function), " "), (0, _jsx3.default)("td", {}, void 0, res.status === 0 ? '正常' : '异常'));
            }))));
        }
    }]);
    return Charge;
}(_react.Component);

exports.default = Charge;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/sbDevice/batteryInfo/charge/index.jsx
// module id = 1553
// module chunks = 0